import superMeta from '../_ALG_CAT/metaAlgCatNode.mjs'

export default {
    ...superMeta,
    algNodeType: 'UIALG',
    name: '界面基础能力',
    type: 'UI_CALG',
}
